'use strict';

import Loader from '../../_modules/loader/loader';
import FirstOrder from '../../_modules/first-order/first-order';
import ProductDetails from '../../_modules/product-details/product-details';

import { toaster } from '../../_assets/abbott/js/_material';

export default class OrderOverride {
	constructor() {}

	/* Products might have gone out of stock in the meantime
	** Review unit in stock of each flavours in the list of selected products
	*/
	checkStockOrder(_currentStockData){
		let $orderOverrideContainer = $('.form--order-override'),
			_firstOrderProductIds = this.getCurrentOrderProdIds(),
			_currentStock = _currentStockData;

		// needed to iterate throughout the current selected products
		let loopIndex = 0,
			$firstOrderProducts = $orderOverrideContainer.find('.product-details__row'),
			nSelectedProducts = _firstOrderProductIds.length;

		if(!nSelectedProducts){
			toaster('There are no products selected', 'error');
			return false;
		}

		/* note: a loop cannot iterate after each callback. In order to use map,
		** this function calls itself again if the condition is not met.
		** Alternatively, consider using promises
		*/
		function iterateInSelectedProd(){
			if(loopIndex >= nSelectedProducts)
				return false;

			let prodId = _firstOrderProductIds[loopIndex],
				$currentProductRow = $firstOrderProducts.eq(loopIndex),
				$flavoursListing = $currentProductRow.find('.flavours-listing'),
				$mixedFlavour = $flavoursListing.find('li[data-name=Mixed]'),
				$unitsInStock = $currentProductRow.find('.stock-quantity__units');

			let prodPos = _currentStock.map(function(x) {return x.ProductTypeId; }).indexOf(prodId),
				_flavours = _currentStock[prodPos].Flavours;

			for (var i = 0, len = _flavours.length; i < len; i++) {

				$flavoursListing
					.find('li[data-prod-id=' + _flavours[i].ProductId + ' ]')
					.attr('data-in-stock', _flavours[i].Stock);
			}

			//isMIxed
			if($mixedFlavour.length)
				$mixedFlavour.attr('data-in-stock', _currentStock[prodPos].StockMixedFlavour);

			//selected flavour
			let $selectedFlavour = $flavoursListing.find('.selected'),
				selectedFlavourUnits = parseInt($selectedFlavour.attr('data-in-stock')),
				$selectedFlavourQuantity = $currentProductRow.find('.counter-value'),
				selectedQuantity = parseInt($selectedFlavourQuantity.val()),
				$selectedFlavourSohLabel = $currentProductRow.find('.stock-quantity__label');

			$unitsInStock
				.text(selectedFlavourUnits); 

			if(selectedQuantity > selectedFlavourUnits)
				$selectedFlavourSohLabel.addClass('show');
			else
				$selectedFlavourSohLabel.removeClass('show');

			loopIndex++;
			iterateInSelectedProd();
		}

		iterateInSelectedProd();
	};

	/* Display new section where users can override first order.
	** Changes should not affect regimen, hence create regimen is hidden.
	**/
	displayFirstOrder(_currentStockData){
		let $createRegimenForm = $('section.dashboard'),
			$orderOverrideContainer = $('.form--order-override'),
			$firstOrderFooter = $orderOverrideContainer.find('.product-details__footer');

		//need to clone first order defined in create regimen
		let	firstOrder = new FirstOrder(),
			$firstOderContainer = firstOrder.getFirstOrderContainer(),
			$firstOrderProductRow = $firstOderContainer.find('.product-details__row'),
			$regimenFirstOrder,
			loader = new Loader();

		//additional markup needed for SOH.
		let $stockDetails = `<span class="stock-quantity__units"> </span>
							<span> &nbsp; </span>
							<span> unit(s) left </span>
							<span class="stock-quantity__label"> Insufficient Stock </span>`;

		loader.fadeIn();

		//Create markup then display first order products
		$regimenFirstOrder = $firstOrderProductRow.clone(true);
		$firstOrderFooter.before($regimenFirstOrder);

		let $orderOverrideRow = $orderOverrideContainer.find('.product-details__row');

		for (let index =0, len = $firstOrderProductRow.length; index < len; index++){
			$orderOverrideRow.eq(index)
				.find('.stock-quantity')
				.html($stockDetails);
		}

		$orderOverrideContainer.addClass('show');
		
		//Hide sections related to Create Regimen
		$createRegimenForm.addClass('hide');

		loader.fadeOut();

	};

	getCurrentOrderProdIds(){
		let $orderOverrideContainer = $('.form--order-override'),
			$firstOrderProducts = $orderOverrideContainer.find('.product-details__row'),
			_products = [];

		$firstOrderProducts.each(function(index){
			let $this = $(this),
				prodTypeId = $this.data('prod-type-id');

			_products[index] = prodTypeId;
		});

		return _products;
	};

	getCurrentStock(){
		let that = this,
			postCode = $('#postal_code').val(),
			isCreateRegimen = $('.dashboard').length,
			isOrderOverride = $('.form--order-override').is(':visible'),
			institutionId = $('#InstitutionId').val(),
			dataParams = {'postcode': postCode, 'institutionId': institutionId}; 

		let encodedParams = jQuery.param(dataParams);
		$.ajax({
	        url: '/api/products/stock?'+encodedParams,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
	        type: 'GET',
	        success: function (data) {
	        	if (data.length){
	        		if(isCreateRegimen && !isOrderOverride)
	        			that.displayFirstOrder(data);

	        		that.checkStockOrder(data);

	        		//TODO: consider refactoring. This was a quick way to deal with SOH with the current codebase, eg product-details.js
	        		let $activePhase = $('.form--order-override'),
	                    $parent = $activePhase.find('.add-products__enclosure'),
	                    $list = $activePhase.find('.products-list__wrap');

	                //initialise product listing any time SOH is checked
	        		let pd = new ProductDetails();
	        		pd.displayAllProducts($activePhase, $parent, $list, data);
	        	}
	        	else
	        		toaster('Something went wrong.','error');
	        },
	        error: function (error) {
	        	toaster('Something went wrong.','error');
	        }
	    });
	};
}
